import { supabase } from '../supabaseClient';

/**
 * Unsubscribes web push and removes the row from Supabase while auth is still valid.
 * Call before `supabase.auth.signOut()`.
 */
export async function removePushSubscriptionOnLogout() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return;

    const subJson = subscription.toJSON();
    if (subJson?.endpoint) {
      await supabase
        .from('push_subscriptions')
        .delete()
        .eq('endpoint', subJson.endpoint);
    }
    await subscription.unsubscribe();
  } catch (error) {
    console.error('removePushSubscriptionOnLogout:', error);
  }
}

/**
 * Clears all origin `localStorage`, `sessionStorage`, and Cache Storage entries.
 * Intended after `signOut` so no app or auth data remains on the device.
 */
export async function clearSiteStorageAndCaches() {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.clear();
  } catch (e) {
    console.error('localStorage.clear failed:', e);
  }

  try {
    window.sessionStorage.clear();
  } catch (e) {
    console.error('sessionStorage.clear failed:', e);
  }

  if ('caches' in window && typeof caches?.keys === 'function') {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    } catch (e) {
      console.error('Cache Storage cleanup failed:', e);
    }
  }
}
